import React, { Component } from 'react';
import Toaster from '../../components/ReusableComponents/Toaster/Toaster';
import { toasterSubscriber, messageSubscriber } from '../../services/subscriberService';
import { UniqueID } from '../../services/CommonFunction';
import { withRouter } from 'react-router-dom';
import { staticVar } from '../../services/Constants';

class Layout extends Component {

    state = {
        toasterData: [],
        messageData: [],
        messageObj: {},
        randomId: '',
        status: false
    }

    componentDidMount() {
        // let count = 0;
        this.subscription = toasterSubscriber.getToasterData().subscribe(data => {
            if (data.data.type && data.data.type === 'copy') {
                const temp = this.state.toasterData.filter(el => el.type && el.type === 'copy' && el.id && el.id === data.data.id);
                if (temp.length) {
                    return;
                }
            }
            this.setState(prevState => ({
                toasterData: [...prevState.toasterData, data.data]
            }));
        });

        this.messageSubscription = messageSubscriber.getMessageData().subscribe(data => {
            const temp = this.state.messageData.length ? this.state.messageData.filter(el => el.message_id === data.data.message_id) : [];
            if (temp.length) {
                return;
            }
            this.setState(prevState => ({
                messageData: [...prevState.messageData,
                { ...data.data, randomId: UniqueID() }]
            }));
        });
    }

    componentDidUpdate = async (nextProps, nextState) => {
        if (this.state.toasterData.length && this.state.toasterData !== nextState.toasterData) {
            setTimeout(() => {
                this.setState(prevState => ({
                    toasterData: prevState.toasterData.splice(1, prevState.toasterData.length - 1)
                }));
            }, 3000);
        }

        if (this.state.messageData.length && this.state.messageData !== nextState.messageData
            && this.state.messageData[0].randomId !== this.state.randomId &&
            this.props.location.pathname === staticVar.liveWorkoutPathName) {
            await this.setState({
                randomId: this.state.messageData[0].randomId,
            });
            setTimeout(() => {
                this.setState({
                    status: true
                })
            }, 1000)
            setTimeout(async () => {
                await this.setState(prevState => ({
                    messageData: prevState.messageData.splice(1, prevState.messageData.length - 1),
                    randomId: null,
                    status: false
                }));
            }, 4000);
        }
    }

    componentWillUnmount() {
        this.messageSubscription.unsubscribe();
    }

    render() {
        const toast = this.state.toasterData.map((el, index) => <Toaster key={index} data={el} />);
        return (
            <React.Fragment>
                <div className="toaster_div">
                    {toast}
                </div>
                <div style={{ position: 'relative' }} onScroll={el => null}>
                    {this.props.children}
                </div>
            </React.Fragment>
        );
    }

}

export default withRouter(Layout);